<button class="pm-language-selector-button" mat-flat-button [matMenuTriggerFor]="languageMenu">
  {{languageName}} @if (isDefault) {
  <span class="mat-small">{{'language-selector.default-lang' | translate}}</span>
}
<mat-icon>keyboard_arrow_down</mat-icon>
</button>

<mat-menu #languageMenu="matMenu">
  @for (language of languages; track language) {
    <button mat-menu-item (click)="selectLanguage(language)" [disabled]="!languageIsMapped(language)">
      {{language.name}} @if (language.isDefault) {
      <span class="mat-small">{{'language-selector.default-lang' | translate}}</span>
    }
  </button>
}
</mat-menu>
